import { computed, ComputedRef, inject, provide } from "vue";
import { FeatureFlagConfig } from "@fresh8/types/src/featureFlags";

export type FeatureFlagContext = ReturnType<typeof useFeatureFlag>;

function useFeatureFlag(
  config?: FeatureFlagConfig
): ComputedRef<FeatureFlagConfig> {
  const params = computed(
    () => new URLSearchParams(document.location.search.substring(1))
  );

  const additionalBadgeSizes = computed(
    () =>
      (config && config.additionalBadgeSizes) ||
      params.value.get("useBadges") === "true"
  );

  return computed(() => ({
    additionalBadgeSizes: additionalBadgeSizes.value
  }));
}

export const FeatureFlagSymbol = Symbol("FeatureFlagSymbol");

export function provideFeatureFlag(config?: FeatureFlagConfig): void {
  return provide(FeatureFlagSymbol, useFeatureFlag(config));
}
export function injectFeatureFlag(): FeatureFlagContext | undefined {
  return inject<FeatureFlagContext>(FeatureFlagSymbol);
}
